import { EnumLanguage } from '@libs/constants';

//** DATA */
export const LEGAL_COOKIE_PREFERENCES_DATA: Partial<Record<EnumLanguage, ILegalCookieSettingsData>> = {
	[EnumLanguage.EN]  : {
		title 	 	   : 'Cookie Preferences',
		essential	   : {
			title: 'Essential Cookies (Necessary)',
			info : `These cookies are vital for our platform's functionality and business operations. They enable login, session
			management, anonymous reach measurement, and site security. Without these cookies, our services may not
			function correctly, and certain features may be unavailable.`
		},
		functional 	   : {
			title: 'Functionality Cookies (Necessary)',
			info : `These cookies are essential for the functioning of our website and services. They enable basic features like
			saving your profile settings, page navigation and access to secure areas of the website. For instance, they
			allow you to log in to secure areas of our website, use payments services, and much more. The website cannot
			function properly without these cookies.`
		},
		socialMedia    : {
			title: 'Social Media Cookies',
			info : `These cookies enable content sharing on social media platforms and facilitate direct interaction with social
			media features, including chat functionality, and others. They may also collect information about your
			social media activity.`
		},
		analytical 	   : {
			title: 'Analytical Cookies',
			info : `These cookies help us understand how visitors interact with our website. They provide information about
			areas visited, time spent on the website, and any issues encountered, such as error messages. This helps us
			improve the way our website works.`
		},
		cookieSettings : {
			title: 'Your Cookie Settings',
			info : `You can use this page to configure your settings concerning cookies and similar technologies that we use on
			our platform. Please note that the settings on this page only affect our website. You can configure your
			settings separately in our Android and iOS app in the app settings. You can deactivate the use of cookies in
			your browser settings, but please be aware that we do not take into account potential "Do Not Track" signals
			in your browser's HTTP header or an app due to a lack of standardization. Please note that restricting the
			use of cookies may negatively impact your ability to use our website and its services. Consent for cookies
			is considered given if the browser settings are set to accept such cookies.`
		}
	},
	[EnumLanguage.DE]  : {
		title 	 	   : 'Cookie-Einstellungen',
		essential	   : {
			title: 'Wesentliche Cookies (Notwendig)',
			info : `Diese Cookies sind für die Funktionalität und den Geschäftsbetrieb unserer Plattform von entscheidender Bedeutung. Sie ermöglichen die Anmeldung und Sitzung
			Verwaltung, anonyme Reichweitenmessung und Website-Sicherheit. Ohne diese Cookies könnten unsere Dienste möglicherweise nicht verfügbar sein
			funktionieren ordnungsgemäß und bestimmte Funktionen sind möglicherweise nicht verfügbar.`
		},
		functional 	   : {
			title: 'Funktionalitäts-Cookies (notwendig)',
			info : `Diese Cookies sind für das Funktionieren unserer Website und Dienste unerlässlich. Sie ermöglichen grundlegende Funktionen wie
			Speichern Ihrer Profileinstellungen, Seitennavigation und Zugriff auf sichere Bereiche der Website. Zum Beispiel sie
			ermöglichen es Ihnen, sich in sicheren Bereichen unserer Website anzumelden, Zahlungsdienste zu nutzen und vieles mehr. Die Website kann nicht
			ohne diese Cookies ordnungsgemäß funktionieren.`
		},
		socialMedia    : {
			title: 'Social-Media-Cookies',
			info : `Diese Cookies ermöglichen das Teilen von Inhalten auf Social-Media-Plattformen und erleichtern die direkte Interaktion mit sozialen Netzwerken
			Medienfunktionen, einschließlich Chat-Funktionalität und andere. Sie können auch Informationen über Sie sammeln
			Social-Media-Aktivitäten.`
		},
		analytical 	   : {
			title: 'Analytische Cookies',
			info : `Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren. Sie geben Auskunft über
			besuchte Bereiche, auf der Website verbrachte Zeit und alle aufgetretenen Probleme, wie z. B. Fehlermeldungen. Das hilft uns
			die Funktionsweise unserer Website zu verbessern.`
		},
		cookieSettings : {
			title: 'Ihre Cookie-Einstellungen',
			info : `Auf dieser Seite können Sie Ihre Einstellungen zu Cookies und ähnlichen Technologien, die wir verwenden, konfigurieren
			unsere Plattform. Bitte beachten Sie, dass die Einstellungen auf dieser Seite nur unsere Website betreffen. Sie können Ihre konfigurieren
			Einstellungen separat in unserer Android- und iOS-App in den App-Einstellungen. Sie können die Verwendung von Cookies deaktivieren
			Bitte beachten Sie jedoch, dass wir potenzielle „Do Not Track“-Signale nicht berücksichtigen
			im HTTP-Header Ihres Browsers oder einer App aufgrund mangelnder Standardisierung. Bitte beachten Sie, dass die Einschränkung der
			Die Verwendung von Cookies kann sich negativ auf Ihre Nutzung unserer Website und ihrer Dienste auswirken. Einwilligung für Cookies
			Dies gilt als gegeben, wenn der Browser so eingestellt ist, dass er solche Cookies akzeptiert.`
		}
	}
};


//** Interfaces --------------------------------- */
export interface ILegalCookieSettingsData {
	title 	   : string;
	essential  : {
		title: string;
		info : string;
	};
	functional : {
		title: string;
		info : string;
	};
	socialMedia: {
		title: string;
		info : string;
	};
	analytical : {
		title: string;
		info : string;
	};
	cookieSettings: {
		title: string;
		info : string;
	};
}
